import { Injectable } from '@angular/core';
import { FilterFieldConfig } from '../filter.component';
import { AllocationStatus } from '../../../enums/allocation-status';


@Injectable({
  providedIn: 'root'
})
export class AllocationsFilterBuilder {
  private fields: FilterFieldConfig[] = [];

  constructor() {}

status(): AllocationsFilterBuilder {
  this.fields.push({
    name: 'status',
    label: 'Status izravne dodjele',
    type: 'select',
    multiple: false,
    options: [
      { label: 'Skica',                               value: AllocationStatus.Draft },
      { label: 'Izravna dodjela predana',             value: AllocationStatus.Submitted },
      { label: 'Izravna dodjela vraćena na doradu',   value: AllocationStatus.Returned },
      { label: 'Izravna dodjela ponovno predana',     value: AllocationStatus.Resubmitted },
      { label: 'Izravna dodjela odobrena',            value: AllocationStatus.Approved },
      { label: 'Izravna dodjela odbijena',            value: AllocationStatus.Rejected },
    ],
    placeholder: 'Odaberite status',
  });
  return this;
}

  years(fromYear: number, yearsCount: number = 100): AllocationsFilterBuilder {
    const options = Array.from({ length: yearsCount }, (_, i) => ({
      label: (fromYear + i).toString(),
      value: fromYear + i
    }));

    this.fields.push({
      name: 'year',
      label: 'Godina',
      type: 'select',
      multiple: false,
      options,
      placeholder: 'Odaberite godinu',
      initialValue: fromYear
    });
    return this;
  }


  reset(): AllocationsFilterBuilder {
    this.fields = [];
    return this;
  }

  build(): FilterFieldConfig[] {
    return this.fields;
  }
}